import { IncomingMessage } from 'http'
import {
  Iata,
  IataSchema,
  LocaleSchema,
  PlatformConfig,
  PlatformConfigSchema,
} from '@reward-platform/shared-schemas'
import {
  DEFAULT_OP_CO,
  getDefaultPlatformConfig,
  getOpCoMetaConfig,
  getWhitelabelOpCoForHost,
  isOpCoEnabledForAvios,
  isWhitelabelPlatform,
} from '~/utils/platform'
import { AVIOS_PLATFORM_COOKIES, getCookiesFromRequest } from './cookies'

export const validateOpCo = (maybeOpCo: unknown) => {
  const opCoParse = IataSchema.safeParse(maybeOpCo)
  if (!opCoParse.success) {
    return DEFAULT_OP_CO
  }
  const isAviosEnabled = isOpCoEnabledForAvios(opCoParse.data)
  if (!isAviosEnabled) {
    return DEFAULT_OP_CO
  }

  return opCoParse.data
}

export const validateOpCoLocale = (opCoCode: Iata, locale: unknown) => {
  const localeParse = LocaleSchema.safeParse(locale)
  const { localeOptions } = getOpCoMetaConfig(opCoCode)
  if (!localeParse.success || !localeOptions.includes(localeParse.data)) {
    const defaultConfig = getDefaultPlatformConfig(opCoCode)
    return defaultConfig.locale
  }

  return localeParse.data
}

export const validateOpCoMarket = (opCoCode: Iata, market: unknown) => {
  if (!market || typeof market !== 'string') {
    const defaultConfig = getDefaultPlatformConfig(opCoCode)
    return defaultConfig.market
  }

  return market
}

export const getPlatformConfigFromCookies = (
  cookies: Record<string, string | undefined>
): PlatformConfig => {
  const maybeOpCoCookie = cookies[AVIOS_PLATFORM_COOKIES.AVIOS_OP_CO]
  const maybeLocaleCookie = cookies[AVIOS_PLATFORM_COOKIES.AVIOS_LOCALE]
  const maybeMarketCookie = cookies[AVIOS_PLATFORM_COOKIES.AVIOS_MARKET]

  const opCo = validateOpCo(maybeOpCoCookie)
  const locale = validateOpCoLocale(opCo, maybeLocaleCookie)
  const market = validateOpCoMarket(opCo, maybeMarketCookie)

  return PlatformConfigSchema.parse({ opCo, locale, market, theme: 'avios' })
}

export const getPlatformOpCoFromRequest = (request: IncomingMessage): Iata => {
  if (isWhitelabelPlatform()) {
    const requestHost = request.headers.host
    return getWhitelabelOpCoForHost(requestHost)
  }

  const cookies = getCookiesFromRequest(request)
  const { opCo } = getPlatformConfigFromCookies(cookies)

  return opCo
}
